import React from 'react';

import {Events} from 'src/analytics';
import {CATEGORY, EDITORIAL, PODCAST} from 'src/routes/paths';
import {ChiefLogo} from 'src/svgs/chiefLogo';

import {SanityLabelledImage, Maybe, SanityImageWithAlt} from 'types/generated';

interface GridCardProps {
  eyebrowClasses: string;
  cardColClasses?: string;
  category?: Maybe<string>;
  editorialCategory: any;
  cardDescriptionClasses?: string;
  cardDescription?: any;
  contentClasses?: string;
  key?: Maybe<any>;
  image: Maybe<SanityLabelledImage>;
  imageClasses?: string;
  url?: Maybe<string>;
  slug?: Maybe<string>;
  title: Maybe<string>;
  titleClasses?: string;
  isPodcast?: Maybe<boolean>;
  episodeImage?: Maybe<SanityImageWithAlt>;
}

export const GridCard: React.FC<GridCardProps> = ({
  title,
  cardColClasses,
  category,
  image,
  imageClasses,
  contentClasses,
  titleClasses,
  editorialCategory,
  url,
  slug,
  cardDescription,
  cardDescriptionClasses,
  eyebrowClasses,
  isPodcast,
  episodeImage,
}: GridCardProps) => {
  const cardImgSrc = isPodcast && episodeImage ? episodeImage.asset?.url : image ? image.asset?.url : '';
  const cardLink = `${isPodcast == true ? PODCAST : EDITORIAL}/${slug}`;
  const cardImgAlt = isPodcast && episodeImage?.imageAltTag ? episodeImage?.imageAltTag : image?.altText ?? '';
  const handleImageClick = (item: string) => () => {
    Events.didClickImage({
      item,
      pageLocation: 'gridCard',
      sectionName: 'Index',
      linkUrl: `${url ?? cardLink}`,
    });
  };
  const handleTitleClick = (item: string) => () => {
    Events.didClickArticle({
      item,
      pageLocation: 'gridCard',
      sectionName: 'Index',
      linkUrl: `${url ?? cardLink}`,
    });
  };
  const categoryDisplay = (editorialCategory && editorialCategory.title) || (category ?? '');
  return (
    <div className={cardColClasses} key={title}>
      <a
        className={'relative bg-green-dark ' + (imageClasses || null)}
        href={url ?? cardLink}
        onClick={handleImageClick(title as string)}
      >
        {cardImgSrc ? (
          <img className="absolute w-full h-full object-cover bg-blackr" src={cardImgSrc || ''} alt={cardImgAlt} />
        ) : (
          <div className="absolute w-full h-full object-cover bg-black flex items-center justify-center">
            <ChiefLogo classes={'mb-2 lg:mb-0 h-[18px] lg:w-25 lg:h-[8%] fill-light-gold'} />
          </div>
        )}
      </a>
      <div className={contentClasses}>
        {editorialCategory?.slug ? (
          <a
            href={`${CATEGORY}/${editorialCategory.slug.current}`}
            className={'block type-eyebrow link-eyebrow mb-2 ' + (eyebrowClasses || 'text-green-dark')}
          >
            {editorialCategory.title}
          </a>
        ) : categoryDisplay != '' ? (
          <span className={'block type-eyebrow mb-2 ' + (eyebrowClasses || 'text-green-dark')}>{categoryDisplay}</span>
        ) : null}
        <h3 className={titleClasses}>
          <a href={url ?? cardLink} className="link-text" onClick={handleTitleClick(title as string)}>
            {title}
          </a>
        </h3>
        {!!cardDescription && <p className={'py-4 ' + (cardDescriptionClasses || null)}>{cardDescription}</p>}
      </div>
    </div>
  );
};
